import { useEffect } from "react";
import { useUser } from "../contexts/user";

export function LogoutView({ history }) {
  const { logout } = useUser();
  useEffect(() => {
    logout();
    history.replace("/rooms");
  }, []);
  return null;
}

export default LogoutView;
